const SET_REPORT_LIST = (state, payload)  => {
  state.reports = payload;
}

export default {
  SET_REPORT_LIST
}